window.magna ||= {}

magna.scrollIntoView = () => {
  const root = document.getElementById('root')

  if (root.querySelector('.hero')){
  const options = {
    threshold: 0.8,
  }

  const elements = root.querySelectorAll('scroll')
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      entry.target.setAttribute('data-intersection', `${entry.isIntersecting}`)
    })
  }, options)

  const buyObserver = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting || entry.boundingClientRect.top < 200) {
      document.querySelector('.header__bottom')?.classList.add('header__bottom--hide')
    } else {
      document.querySelector('.header__bottom')?.classList.remove('header__bottom--hide')
    }
  })

  const heroObserver = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      document.querySelector('.header')?.classList.remove('header--hide')
      document.querySelector('.header__bottom')?.classList.add('header__bottom--hide')
    } else {
      document.querySelector('.header')?.classList.add('header--hide')
      document.querySelector('.header__bottom')?.classList.remove('header__bottom--hide')
    }
  })

  if (root.querySelector('.buy_block')) buyObserver.observe(root.querySelector('.buy__container'))
  if (root.querySelector('.buy_block')) heroObserver.observe(root.querySelector('.hero'))

    elements?.forEach(element => {
      if (element) {
        observer.observe(element)
      }
    })
  } 
}

subscribe(Event.domready, magna.scrollIntoView)
